import * as z from 'zod';

/** Reject requires a reason (mirrors the API contract). */
export const rejectRequestSchema = z.object({
  reason: z.string().trim().min(3, 'Too short').max(500, 'Too long'),
});
export type RejectRequestInput = z.infer<typeof rejectRequestSchema>;
